import { Box, Button, Modal, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";

const DeleteQcPunchlistItemModal = ({ open, onClose, onDelete, loading }) => {
    return (
        <Modal maxWidth="sm"  open={open} onClose={onClose} aria-labelledby="modal-title" aria-describedby="modal-description">
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "50%",
                    backgroundColor: "#FFFFFF",
                    padding: "10px",
                    boxShadow: 24,
                    borderRadius: 2,
                }}
            >

                <Box mb={2} sx={{ padding: "10px 20px 0", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Typography id="modal-title" variant="h6" component="h2" fontWeight={600}>
                        Confirm Deletion
                    </Typography>
                    <CloseIcon onClick={onClose} sx={{ cursor: "pointer" }} />
                </Box>
             

                {/* Description */}
                <Box sx={{ padding: "10px 20px" }}>
                    <Typography id="modal-description" sx={{ fontSize: "16px" }}>
                        Deleting the item will delete the photos and comments as well.<br />
                        Please confirm if the status of this item should be changed to "Not Started" or "Pass" in the QC checklist.
                    </Typography>
                </Box>

                {/* Buttons */}
                <Box sx={{ padding: "30px 20px", display: "flex", justifyContent: "end" }}>
                    <Button loading={loading} variant="contained" sx={{ marginRight: "10px" }}  onClick={() => onDelete(0)}>
                        Mark as Not Started
                    </Button>
                    <Button variant="contained" loading={loading} onClick={() => onDelete(1)}>
                        Mark as Pass
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default DeleteQcPunchlistItemModal;
